import { createAsyncAction } from 'redux-promise-middleware-actions';
import { getFilteredWebinars } from 'Api/Webinar/webinarService';

export const searchWebinars = createAsyncAction('COPY_SEARCH_WEBINARS', getFilteredWebinars);
